import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import { useFilter } from "../../Context/FilterContext";
import ajaxStationSales from "../../util/remote/ajaxStationSales";

const MonthlyAttendantSales = () => {
  const { toggleFilter, filterVisible } = useFilter();
  const { userId } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [salesList, setSalesList] = useState([]);
  var station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));

  // Helpers for formatting numbers
  const formatNumber = (num) => {
    if (!num) return "0";
    return Number(num).toLocaleString();
  };

  const formatAmount = (num) => {
    if (!num) return "0.00";
    return Number(num).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // Filters
  const [month, setMonth] = useState(() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
  });

  // Fetch Monthly Attendant Sales
  const fetchSales = async () => {
    setLoading(true);
    const compactMonth = month.replace("-", "");
    const data = {
      station_id: station_idd,
      month: compactMonth,
    };

    setSalesList([]);
    const response = await ajaxStationSales.monthly_attendant_sales(data);
    setLoading(false);
    if (response.status === "OK") {
      setSalesList(response.details);
    } else {
      toast.error(response.message);
    }
  };

  useEffect(() => {
    fetchSales();
  }, [month]);

  return (
    <AppContainer
      title="Monthly Attendant Sales"
      previousPageTitle="Dashboard"
      actions={[
        {
          label: "filter",
          icon: "fa-solid fa-filter",
          className: "btn btn-warning btn-sm",
          onClick: () => toggleFilter(),
        },
      ]}
    >
      <div className="container-fluid">
        <Toaster />

        {/* FILTERS */}
        {filterVisible && (
          <div className="row">
            <div className="col-12">
              <div className="card shadow-sm border-0 rounded-3">
                <div className="card-body p-4">
                  <div className="bg-light p-3 rounded-3 border mb-3">
                    <div className="row g-3 align-items-end">
                      {/* Month Select */}
                      <div className="col-lg-3">
                        <label className="form-label fw-semibold">Month</label>
                        <input
                          type="month"
                          className="form-control"
                          value={month}
                          onChange={(e) => setMonth(e.target.value)}
                        />
                      </div>

                      {/* Apply Button */}
                      <div className="col-lg-3 d-flex justify-content-end">
                        <button
                          className="btn btn-primary btn-sm m-2"
                          onClick={fetchSales}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* LOADING / EMPTY */}
        {loading ? (
          <div className="text-center my-5 fs-5 text-muted">Loading...</div>
        ) : salesList.length === 0 ? (
          <div className="text-center my-5 fs-5 text-muted">
            No Sales Found For This Month
          </div>
        ) : (
          <>
            {/* TABLE */}
            <div className="row">
              <div className="col-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <h6 className="card-title mb-1">
                      Monthly Sales Per Attendant
                    </h6>
                    <p className="text-muted card-sub-title">
                      Summary of litres and total sales
                    </p>

                    <div className="table-responsive">
                      <table className="table table-bordered text-nowrap mb-0">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Attendant</th>
                            <th>Total Litres</th>
                            <th>Total Amount</th>
                          </tr>
                        </thead>

                        <tbody>
                          {salesList.map((item, index) => (
                            <tr key={item.attendant_id}>
                              <td>{index + 1}</td>
                              <td>
                                {item.first_name} {item.last_name}
                              </td>
                              <td>{formatNumber(item.total_litres)}</td>
                              <td>UGX {formatAmount(item.total_amount)}/=</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </AppContainer>
  );
};

export default MonthlyAttendantSales;
